import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon, FileTextIcon, MessageSquareIcon, PencilIcon, ZapIcon } from 'lucide-react';
const helps = ['cuando estás saturado;', 'cuando recibís un mensaje que te enoja;', 'cuando tenés que enfrentar una conversación difícil;', 'cuando no sabés cómo responder;', 'cuando todo parece urgente;', 'cuando necesitás poner un límite;', 'cuando una discusión sigue dando vueltas en tu cabeza;', 'o cuando simplemente necesitás terminar el día y desconectar.'];
const includes = [{
  icon: LayersIcon,
  text: '4 materiales completos'
}, {
  icon: FileTextIcon,
  text: '+60 páginas'
}, {
  icon: MessageSquareIcon,
  text: '100 respuestas listas para usar'
}, {
  icon: PencilIcon,
  text: 'Ejercicios prácticos'
}, {
  icon: ZapIcon,
  text: 'Acceso inmediato'
}];
export function ProductPresentation() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-246" data-mp="2qx5rsp9m275r">
      <div className="max-w-4xl mx-auto" data-id="element-247" data-mp="2zbdh5ez6e0xm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-248" data-mp="2z896pzv4a8yi">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-5" data-id="element-249" data-mp="3i01vfi35l80f">
            <span className="text-xs font-bold tracking-widest" data-id="element-250" data-mp="3dygd3h7uo1iu">🏆 EL KIT</span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-251" data-mp="3rxy7qd7tu904">
            No es otro libro sobre estrés.
          </h2>
          <p className="font-serif-italic text-rose text-xl md:text-2xl mt-3" data-id="element-252" data-mp="1xk6qosn64mun">
            Son herramientas para usar mientras trabajás.
          </p>
          <p className="text-ink-soft text-base md:text-lg mt-6 max-w-2xl mx-auto leading-relaxed" data-id="element-253" data-mp="1snzvnuwb8vrh">
            El Kit Antiestrés para el Trabajo fue creado para ayudarte a actuar
            en esos momentos cotidianos que van acumulando desgaste:
          </p>
        </motion.div>

        <motion.ul initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white border border-line rounded-3xl p-6 md:p-10 shadow-sm grid sm:grid-cols-2 gap-x-8 gap-y-3" data-id="element-254" data-mp="5i3z9w1sumnn">
          {helps.map((h, i) => <li key={i} className="flex items-start gap-3" data-id="element-255" data-mp="t99i8k31dv26" data-mpi={i}>
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-256" data-mp="y84825zf8jvs">
                <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-257" data-mp="136nv69pr41pq" />
              </span>
              <span className="text-ink text-sm md:text-base" data-id="element-258" data-mp="1daulfgm3ldod">{h}</span>
            </li>)}
        </motion.ul>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-wrap items-center justify-center gap-2.5 mt-10" data-id="element-259" data-mp="18brlgakz5xn9">
          {includes.map((c, i) => <div key={i} className="inline-flex items-center gap-2 bg-rose-bg border border-rose/20 text-ink text-sm font-semibold px-4 py-2.5 rounded-full" data-id="element-260" data-mp="1w13xdi7osjt9" data-mpi={i}>
              <c.icon className="w-4 h-4 text-rose" data-id="element-261" data-mp="1ma98e6323644" />
              {c.text}
            </div>)}
        </motion.div>
      </div>
    </section>;
}